import { render } from "./media_upload.vue?vue&type=template&id=6bb23d2c"
import script from "./media_upload.js?vue&type=script&lang=js"
export * from "./media_upload.js?vue&type=script&lang=js"

import "./media_upload.vue?vue&type=style&index=0&id=6bb23d2c&lang=scss"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__